export default __webpack_public_path__ + "static/media/developer.3da348ef.svg";